import { baseQueryWithAuth } from './utils';
import { createApi } from '@reduxjs/toolkit/query/react';

import type {
  NetworkGroupData as NetworkGroup,
  NetworkGroupValuesPage,
} from '@/generated/types/navigator/types.gen';
import type { GroupId } from './types';

type NetworkGroupValuesArgs = {
  groupId: GroupId;
  q: string;
  cursor?: string;
  limit?: number;
};

// Create a slice for dev mode settings
export const networkGroupApi = createApi({
  reducerPath: 'networkGroupApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    fetchNetworkGroups: builder.query<NetworkGroup[], void>({
      query: () => ({
        url: `/v1/network_group/all`,
      }),
    }),
    fetchNetworkGroupsWithValues: builder.query<NetworkGroup[], void>({
      query: () => ({
        url: `/v1/network_group/all_values`,
      }),
    }),
    fetchNetworkGroupValues: builder.query<
      NetworkGroupValuesPage,
      NetworkGroupValuesArgs
    >({
      query: ({ groupId, q, cursor, limit }) => ({
        url: `/v1/network_group/${groupId}/values`,
        params: { q, cursor, limit },
      }),
    }),
  }),
});

export const {
  useFetchNetworkGroupsQuery,
  useFetchNetworkGroupsWithValuesQuery,
  useLazyFetchNetworkGroupValuesQuery,
} = networkGroupApi;

export const fetchNetworkGroups =
  networkGroupApi.endpoints.fetchNetworkGroups.matchFulfilled;

export const resetNetworkGroupSlice = networkGroupApi.util.resetApiState;
